import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyB3mWCKV51PCaqswd2U4sSu2O7RJ6gY6kA",
  authDomain: "pipplus-contact.firebaseapp.com",
  projectId: "pipplus-contact",
  storageBucket: "pipplus-contact.firebasestorage.app",
  messagingSenderId: "947381206468",
  appId: "1:947381206468:web:1b812697b81a3f2043f891"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export { db };